<template>
  <div class="Main">
    <div class="allImage fl">
      <video
        class="video"
        :src="Ysjx"
        autoplay
        loop
        playsinline
        webkit-playsinline
        muted
        poster=""
        controlslist="nodownload"
        preload="auto"
      ></video>
    </div>
    <div class="por" v-for="(v, k) in bannerList" :key="k">
      <img class="allImage" :src="v.src" alt="" />
      <div class="text_el">
        <div>源AI</div>
        <div>数字人实时交互AI人工智能多场景应用</div>
        <el-button class="btn_el" @click="routeClick(v.path)"
          >查看详情</el-button
        >
      </div>
    </div>
    <div class="por" v-for="(v, k) in YYZList" :key="k">
      <!-- <img class="allImage" :src="v.src" alt="" /> -->
      <div class="allImage">
        <video
          class="YZZvideo"
          style="object-fit: cover"
          :src="YYZ"
          autoplay
          loop
          playsinline
          webkit-playsinline
          muted
          poster=""
          controlslist="nodownload"
          preload="auto"
        ></video>
      </div>
      <div class="text_el" style="color: #000">
        <div>元宇宙</div>
        <div>虚拟增强现实前所未有的体验</div>
        <el-button class="btn_el" @click="routeClick(v.path)"
          >查看详情</el-button
        >
      </div>
    </div>
    <div class="por" v-for="(v, k) in SZLSList" :key="k">
      <!-- <img class="allImage" :src="v.src" alt="" /> -->
      <div class="allImage">
        <video
          class="YZZvideo"
          style="object-fit: cover"
          :src="SZLS"
          autoplay
          loop
          playsinline
          webkit-playsinline
          muted
          poster=""
          controlslist="nodownload"
          preload="auto"
        ></video>
      </div>
      <div class="text_el" style="color: #000">
        <div>数字孪生</div>
        <div>智能决策 高效管理 风险预测可视化展示</div>
        <el-button class="btn_el" @click="routeClick(v.path)"
          >查看详情</el-button
        >
      </div>
    </div>
    <div class="por" v-for="(v, k) in XNZPList" :key="k">
      <img class="allImage" :src="v.src" alt="" />
      <div class="text_el">
        <div>虚拟制片</div>
        <div>创意无限高效制作成本节约</div>
        <el-button class="btn_el" @click="routeClick(v.path)"
          >查看详情</el-button
        >
      </div>
    </div>
    <div class="por" v-for="(v, k) in TravelList" :key="k">
      <img class="allImage" :src="v.src" alt="" />
      <div class="text_el">
        <div>智旅新篇</div>
        <div>佩戴VR 角色扮演 身临其境</div>
        <el-button class="btn_el" @click="routeClick(v.path)"
          >查看详情</el-button
        >
      </div>
    </div>
    <div class="setAllBox" v-for="(v, k) in footerList" :key="k">
      <div class="por">
        <img
          class="allImage"
          style="height: 100%; overflow: hidden"
          :src="v.src"
          alt=""
        />
        <div class="text_el_footer">
          <div>{{ v.title }}</div>
          <div>{{ v.msg }}</div>
          <el-button class="btn_el" @click="firClick(v)">查看详情</el-button>
        </div>
      </div>
      <div class="por" style="margin-right: 0px">
        <img
          class="allImage"
          style="height: 100%; overflow: hidden"
          :src="v.otherSrc"
          alt=""
        />
        <div class="text_el_footer">
          <div>{{ v.othertitle }}</div>
          <div>{{ v.othermsg }}</div>
          <el-button class="btn_el" @click="secClick(v)">查看详情</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

import Ysjx from "@/assets/home/home.mp4";
import XQ from "@/assets/XQ.webp";
import YYZ from "@/assets/home/header.mp4";
import SZLS from "@/assets/home/1218.mp4";
import XNZP from "@/assets/XNZP.webp";
import XSZG from "@/assets/XSZG.webp";
// import XNZP from "@/assets/XNZP.webp";
import STZG from "@/assets/STZG.webp";
import Travel from "@/assets/Travel/zlxp.webp";
import VR from "@/assets/VR.webp";
import VisionPro from "@/assets/VisionPro.webp";

import { onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
const router = useRouter();
const bannerList = ref([{ src: XQ, path: "/YuanAI" }]);
const XNZPList = ref([{ src: XNZP, path: "/bition" }]);
const YYZList = ref([{ src: YYZ, path: "/Metaverse" }]);
const SZLSList = ref([{ src: SZLS, path: "/Digital" }]);
const TravelList = ref([{ src: Travel, path: "/Travel" }]);
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
const firClick = (v) => {
  scrollToTop();
  router.push({ path: v.path });
};
const secClick = (v) => {
  scrollToTop();
  router.push({ path: v.otherpath });
};
const footerList = ref([
  {
    path: "/exhibition",
    src: XSZG,
    otherSrc: STZG,
    otherpath: "/exhibition",
    othertitle: "实体展馆",
    othermsg: "科技互动实体展馆专业布展安全保障",
    title: "线上展馆",
    msg: "步进式全景展示 便捷观展 沉浸式体验",
  },
  {
    path: "/VR",
    src: VR,
    otherSrc: VisionPro,
    otherpath: "/VP",
    othertitle: "Vision Pro",
    othermsg: "混合现实空间算法开启未来视界",
    title: "VR大空间",
    msg: "创新科技 震撼体验 多领域应用",
  },
]);
const routeClick = (path) => {
  scrollToTop();
  router.push({ path: path });
};

// 监听滚动事件
onMounted(() => {});

onUnmounted(() => {});
</script>
<style scoped lang="scss">
@import "./index.scss";
</style>
